import { SettingApi } from "lib/api";
import { ApiHelper, Http } from "lib/api/base";

import { DataField } from "lib/data/model";

export class DataFieldApi {

	public static getDataFields = async (): Promise<DataField[]> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/DataField`;

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const dataFieldTypes: DataField[] = await ApiHelper.parseResponseBody(response);

				return dataFieldTypes;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return [];
	}

	public static getDataField = async (id: number): Promise<DataField | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/DataField/${id.toString()}`;

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const dataFieldType: DataField = await ApiHelper.parseResponseBody(response);

				return dataFieldType;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}
}
